<template>
	<div id="view-modal">
        <div class="transaction-container">
            <table class="transaction-history-data">
			    <tr>
				    <th>{{ languageStrings.fromPlayerCash }}</th>
				    <td v-if="selectedTransaction.fromPlayerCashCOC >= 0">
                        {{  systemCurrencyTool.formatCurrency(
										selectedTransaction.fromPlayerCashCOC,
										systemCurrencyTool.displayType.minorOrFull
									) }}
                    </td>
                    <td v-else class="negative-value">
                         {{  systemCurrencyTool.formatCurrency(
										selectedTransaction.fromPlayerCashCOC,
										systemCurrencyTool.displayType.minorOrFull
									) }}
                    </td>
			    </tr>
			    <tr>
				    <th>ID</th>
				    <td>{{  selectedTransaction.id }}</td>
			    </tr>
			    <tr>
				    <th>{{ languageStrings.initiationDate }}</th>
				    <td>{{ new Date(selectedTransaction.initiationDate).toLocaleTimeString(
												this.localeString,
												dateOptions
											) }}</td>
			    </tr>
			    <tr>
				    <th>{{ languageStrings.offerExpirationDate }}</th>
				    <td>{{ new Date(selectedTransaction.offerExpirationDate).toLocaleTimeString(
												this.localeString,
												dateOptions
											) }}</td>
			    </tr>
			    <tr>
				    <th>{{ languageStrings.provider }}</th>
				    <td>{{ selectedTransaction.provider }}</td>
			    </tr>
                <tr>
				    <th>{{ languageStrings.providerExpirationDate }}</th>
				    <td v-if="selectedTransaction.providerExpirationDate != null">
                     {{  new Date(selectedTransaction.providerExpirationDate).toLocaleTimeString(
												this.localeString,
												dateOptions
											)}}
                    </td>
                    <td v-else></td>
			    </tr>
                <tr>
				    <th>{{ languageStrings.providerTransactionId }}</th>
				    <td>{{ selectedTransaction.providerTransactionId}}</td>
			    </tr>
                <tr>
				    <th>{{ languageStrings.resolutionDate }}</th>
				    <td>{{   new Date(selectedTransaction.resolutionDate).toLocaleTimeString(
												this.localeString,
												dateOptions
											)}}</td>
			    </tr>
                <tr>
				    <th>{{ languageStrings.status }}</th>
				    <td v-if="selectedTransaction.status === 'Committed'">{{ languageStrings.committed }}</td>
                    <td v-else-if="selectedTransaction.status === 'Cancelled'" >{{ languageStrings.cancelled }}</td>
					<td v-else-if="selectedTransaction.status === 'Expired'" >{{ languageStrings.expired }}</td>
					<td v-else-if="selectedTransaction.status === 'OfferedToUser'" >{{ languageStrings.offeredToUser }}</td>
					<td v-else-if="selectedTransaction.status === 'WaitingForProviderConfirmation'" >{{ languageStrings.waitingForProviderConfirmation }}</td>
					<td v-else-if="selectedTransaction.status === 'RefusedByProvider'" >{{ languageStrings.refusedByProvider }}</td>
			    </tr>
                <tr>
				    <th>{{ languageStrings.statusAdditionalInfo }}</th>
				    <td>{{ selectedTransaction.statusAdditionalInfo}}</td>
			    </tr>
                <tr>
				    <th>{{ languageStrings.promoAmount }}</th>
				    <td>{{  systemCurrencyTool.formatFromAU(
										selectedTransaction.toPlayerAmount.promoAU,
										systemCurrencyTool.displayType.minorOrFull
									)}}</td>
			    </tr>
                <tr>
				    <th>{{ languageStrings.regularAmount }}</th>
				    <td>{{ systemCurrencyTool.formatFromAU(
										selectedTransaction.toPlayerAmount.regularAU,
										systemCurrencyTool.displayType.minorOrFull
									)}}</td>
			    </tr>
				<tr>
				    <th>Total</th>
				    <td>{{ getTotal(selectedTransaction.toPlayerAmount.promoAU,selectedTransaction.toPlayerAmount.regularAU) }}</td>
			    </tr>
                <tr>
				    <th>{{ languageStrings.user }} ID</th>
				    <td>{{ selectedTransaction.userId}}</td>
			    </tr>
		    </table>
            <button class="btn" @click="closeModal()">Close</button>
		</div>
	</div>
</template>

<script>

export default {
	name: "TransactionHistoryAdditionalInformation",
	props: {
		selectedTransaction: Object,
        systemCurrencyTool: Object,
        languageStrings: Object,
	},
	data() {
		return {};
	},
	watch: {},
    created() {},
	methods: {
        closeModal() {
            this.eventBus.emit("closeModal");
        },

		getTotal(promoCredits, regularCredits) {
			let total = promoCredits + regularCredits;
			return this.systemCurrencyTool.formatFromAU(total, this.systemCurrencyTool.displayType.minorOrFull);
		},
	},	
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#view-modal {
    position: fixed;
	display: grid;
	height: 100vh;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: rgb(0 0 0 / 75%);
	-webkit-backdrop-filter: blur(6px);
	backdrop-filter: blur(6px);
	z-index: 1;
}

.transaction-container {
    display: flex;
	flex-flow: column nowrap;
	position: relative;
	top: 15px;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: #222;
	color: #fff;
	width: 90%;
	margin: auto;
	padding: 30px;
	border-radius: 12px;
	text-align: center;
	overflow-y: scroll;
	height: 91vh;
}

tr,td,th {
    border: 1px solid #6305C9;
    background-color: white;
    color: #6305C9;
    font-size: medium;
    font-weight: bold;
    height: 30px;
   
}

.transaction-history-data {
    margin-top: 11vh;
}

.negative-value {
    color: red;
}

@media (min-width: 767px) {
	.transaction-container {
		overflow: hidden;
	}
}


</style>
